module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$props.tasks && _vm.$props.tasks.length) ? _c('div', {
    staticClass: "tasks-list"
  }, _vm._l((_vm.$props.tasks), function(task) {
    return _c('tasks-list-item', {
      key: task.id,
      attrs: {
        "task": task
      }
    })
  })) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cdf1ed0c","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TasksList.vue
// module id = 1255
// module chunks = 0